module.exports = __webpack_public_path__ + "static/media/btn-x-close-small-wht.ddb55841.svg";